<template>
  <v-container fluid ma-0 pa-0>
    <v-img max-height="600" :src="news.image">
      <!--<v-layout align-end justify-end fill-height>
          <v-flex class="text-xs-right">
              <v-btn color="pink" dark large @click="navigate">Register here</v-btn>
          </v-flex>
      </v-layout>-->


    </v-img>
    <v-container grid-list-sm text-xs-left>


      <v-layout column wrap pa-2>
        <v-flex xs12 pa-3>
          <span style="text-align: justify" :class="isMobile() ? 'display-1' :'display-3'"><strong>{{news.title}}</strong></span>
        </v-flex>
        <v-layout row pa-0>
          <v-flex px-3 py-1>
            <span class="subheading"><strong>Publication date: </strong> {{news.publicationDate}}</span>
          </v-flex>
          <v-flex px-3>
            <span class="subheading"><strong>Author: </strong> {{news.author}}</span>
          </v-flex>
        </v-layout>
        <v-divider class="divider"/>
        <v-flex xs12 pa-3>
          <span style="text-align: justify" class="headline newsDescription" v-html="news.content"></span>
        </v-flex>
        <v-flex xs12 pa-3>

        </v-flex>

      </v-layout>

    </v-container>
  </v-container>

</template>

<script>
import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
import TimeService from "@/helpers/TimeService";
import UrlsService from "@/helpers/UrlsService";
import {mapGetters, mapState} from "vuex";
import {values} from "@/utils/values"

export default {
  name: "PublicNewsDetails",
  props: {
    _id: String,
  },
  computed: {
    ...mapState({}),
    ...mapGetters("UserState", {
      user: "getUserInfo",
    }),
  },
  data() {
    return {
      news: {
        title: "",
        content: "",
        publicationDate: "",
        author: "",
        image: values.placeholderImgBase64,
      },
    }
  },
  created() {
    this.getNews();
  },
  methods: {
    isMobile() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    getNews(){
      let requestUrl = {
        url: UrlsService.getNewsById,
        timeout: TimeService.secondsToMillis(0),
      };
      let requestData = {
        _id: this._id,
      };
      let requestObject = {
        type: "public",
        urlsInfo: requestUrl,
        data: {
          data: requestData,
        },
      };
      let messages = {
        title: "News",
        loading: "Waiting for news...",
        error: "Cannot get news...",
      };
      let options = {
        loadingType: "fullscreen",
        timeout: TimeService.secondsToMillis(0),
      };
      APILoaderDecoratorService.setLoader(requestObject, messages, options)
          .then(responseSuccess => {
            this.news = responseSuccess;
          });
    },
  }

}
</script>

<style scoped>

.center-element {
  display: block;
  align-items: center;
}

.newInfo {

}

.newsDescription {
  word-break: break-word;
}

.divider {
  height: 2px;
  alignment: center;
  color: grey;
  opacity: 80%;
  border-color: grey;
}

</style>
